module.exports = __webpack_public_path__ + "media/images/ui-icons_2e83ff_256x240-1c753b4b338b6f900fafbb6873182ef7.png";